import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { RESIDENTS_DESKTOP_COLORS } from '@/constants/residents/desktop/color';
import { Radio } from '@/components/common/Radio';

interface PaymentRadioOptionProps {
  selected: boolean;
  onPress: () => void;
  label: string;
  value?: string;
  rightComponent?: React.ReactNode;
  style?: any;
}

export const PaymentRadioOption: React.FC<PaymentRadioOptionProps> = ({
  selected,
  onPress,
  label,
  value,
  rightComponent,
  style,
}) => {
  return (
    <TouchableOpacity style={[styles.optionRow, style]} onPress={onPress}>
      <View style={styles.optionLeft}>
        <Radio selected={selected} />
        <Text style={styles.optionLabel}>{label}</Text>
      </View>
      {value && (
        <Text style={styles.optionValue}>{value}</Text>
      )}
      {rightComponent}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  optionRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 10,
  },
  optionLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  optionLabel: {
    color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY,
    fontSize: 16,
    marginRight: 8,
    fontWeight: '600',
    marginLeft: 12,
  },
  optionValue: {
    color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY,
    fontSize: 16,
    fontWeight: '600',
  },
});
